import React from 'react';
import {request} from '../helpers/request'
import jQuery from 'jquery'
import ModalComponent from './common/ModalComponent'
import LoadingComponent from './common/LoadingComponent'
import {browserHistory} from 'react-router'
import {t} from '../helpers/translate'
import {getPortal} from '../helpers/access'
import PasswordComponent from './common/PasswordComponent';
let config = require('config');

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      resetEmail: '',
      username: '',
      password: '',
      showPasswordResetModal: false,
      showErrorModal: false,
      hasError: false,
      modalMessage: false,
      loading: false,
    };
    const root = document.documentElement;
    root.style.setProperty("--msh-orange", "#D83D17");
    if (this.isLoggedIn()) {
      window.location.pathname = '/home'
    }

    sessionStorage.removeItem('microsite_colour');
  }

  isLoggedIn() {
    return sessionStorage.getItem('auth') != null && sessionStorage.getItem('org') != null
  }

  handleModalClose() {
    this.setState({
      showPasswordResetModal: false,
      showErrorModal: false,
    })
  }

  handleResetEmailChange(event) {
    this.setState({resetEmail: event.target.value})
  }

  sendPasswordResetEmail() {
    jQuery.ajax(
      {
        url: `${config.default.auth_base_api}/auth/forgotpassword/request`,
        method: 'POST',
        data: {
          email: this.state.resetEmail.replaceAll(' ', ''),
          org: getPortal()
        }
      }
    ).always((response, statusText) => {
      if (statusText == 'success') {
        this.setState({
          showPasswordResetModal: false,
          hasError: true,
          modalMessage: t('A password reset link has been sent to your email.'),
          showErrorModal: true
        })
      } else {
        this.setState({
          hasError: true,
          modalMessage: t('Your request could not be processed. Please try again.'),
          showErrorModal: true
        })
      }
    });
  }

  handleUsernameChange(event) {
    this.setState({username: event.target.value})
  }

  handlePasswordChange(event) {
    this.setState({password: event.target.value})
  }

  handleKeyPress(event) {
    if (event.key == 'Enter') this.getAccessToken()
  }

  showPasswordResetModal() {
    this.setState({
      showPasswordResetModal: true
    })
  }

  getAccessToken() {
    this.setState({loading: true});
    jQuery.ajax(
      {
        url: `${config.default.auth_base_api}/token/travel/user`,
        method: 'POST',
        data: {
          email: this.state.username,
          password: this.state.password,
          org: getPortal(),
        }
      }
    ).always((response, statusText) => {
      this.setState({loading: false})
      if (statusText == 'success') {
        sessionStorage.setItem('auth', 'Bearer' + ' ' + response['access_token']);
        this.getMeAndRedirect();
      } else {
        this.setState({
          hasError: true,
          modalMessage: t('Invalid username and/or password.'),
          showErrorModal: true
        })
      }
    });
  }

  verifyScope(authLevel, responseScopes) {
    return responseScopes.some(elem => config.default.scopes[authLevel].includes(elem))
  }

  setSessionAuthLevel(authLevel, responseScopes){
    if(this.verifyScope(authLevel, responseScopes)){
      sessionStorage.setItem('auth_level', authLevel);
    }
    return true;
  }

  getMeAndRedirect() {
    request(`${config.default.auth_base_api}/me`, 'GET', {}, (responseData, statusCode) => {
      if (statusCode === 200) {
        if (responseData.data.csr_token) {
          sessionStorage.setItem('user_id', responseData.id)
          sessionStorage.setItem('csr_token', responseData.data.csr_token)
          sessionStorage.setItem('org', responseData.org)
          sessionStorage.setItem('school', responseData.data.school)
          responseData.data.all_schools && sessionStorage.setItem('all_schools', responseData.data.all_schools)
          sessionStorage.setItem('scopes', responseData.scopes)
          sessionStorage.setItem('access_level', responseData.access_level)
          sessionStorage.setItem('me', `${responseData.first_name} ${responseData.last_name}`)
        }
        this.setSessionAuthLevel('readonly', responseData.scopes);
        this.setSessionAuthLevel('agent', responseData.scopes);
        this.setSessionAuthLevel('schooladmin', responseData.scopes);
        this.setSessionAuthLevel('schoolsuperadmin', responseData.scopes);
        this.verifyScope('viewonly', responseData.scopes) && sessionStorage.setItem('access_level', 'viewonly');
        this.setSessionAuthLevel('admin', responseData.scopes);
        this.setSessionAuthLevel('superadmin', responseData.scopes);
        this.setSessionAuthLevel('masteradmin', responseData.scopes);
        this.setSessionAuthLevel('mshadmin', responseData.scopes);
      }
      browserHistory.push('/home');
    })
  }

  getPasswordResetModalBody () {
    return <div>
      <div className="col-md-12">
        <input placeholder="email" type="text" name="login"
               onChange={this.handleResetEmailChange.bind(this)} className="form-control"/>
        <br />
        <button onClick={this.sendPasswordResetEmail.bind(this)} type="button" className="btn btn-lg button-primary center-block">
          {t('Request Password Reset')}
        </button>
      </div>
    </div>
  }

  displayLogo() {
    const logo = (config.default.domains[location.hostname] || config.default.domains['default']).logo
    const logoUrl = `https://s3.ca-central-1.amazonaws.com/msh-assets/insurance/${logo}_${t('en')}.png`;
    return <img src={logoUrl} size="lg" />
  }

  displaySchoolLogo() {
    return
  }

  getLogosClass() {
    return 'login-logos';
  }

  render() {
    return <div className="container">
      <div className="text-center bg-inherit">
        <h2 className={this.getLogosClass()}>{this.displaySchoolLogo()}&nbsp;{this.displayLogo()}</h2>
      </div>
      <div className={`form-group-lg ${this.state.hasError ? 'has-error' : ''}`}>
        <div className="row">
          <div className="col-md-3">
          </div>
          <div className="col-md-6">
            <input
              placeholder={t("username/email")}
              type="text"
              name="login"
              onChange={this.handleUsernameChange.bind(this)}
              className="form-control"
            />
            <br />
            <PasswordComponent
              handleKeyPress={this.handleKeyPress.bind(this)}
              type={"login"}
              placeholder={"password"}
              editMode
              onDataChanged={({ _, value }) => {
                this.setState({ password: value });
              }}
            />
          </div>
        </div>
        <br />
        <button onClick={this.getAccessToken.bind(this)} type="button" className="btn btn-lg button-secondary center-block">
          {t('sign in')}
        </button>
        <br />
        <button onClick={this.showPasswordResetModal.bind(this)} type="button" className="btn btn-lg button-primary center-block">
          {t('Forgot Password')}
        </button>

        <ModalComponent
          title="Reset Password"
          body={this.getPasswordResetModalBody()}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showPasswordResetModal}
        />

        <ModalComponent
          body={this.state.modalMessage}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showErrorModal}
        />

        <LoadingComponent show={this.state.loading} text={t('Signing In')}/>

      </div>
    </div>
  }
}

Login.defaultProps = {};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js